import { createHashRouter } from "react-router-dom";
import Index from "../views/Index";
import Login from "../views/Login";
import Logout from "../views/auth/Logout";
import Dashboard from "../views/Dashboard";
import ProtectedRoute from "../views/auth/ProtectedRoute";
import PrivateRoute from "../views/auth/PrivateRoute";
import NotFound from "../views/404"; 
import Cadastro from "../views/Cadastro";
import PasswordResetForm from "../views/VerifyCode";
import Produtos from "../views/armazen/Produto";
import EntradaEstoque from "../views/armazen/EntradaEstoque";
import Clientes from "../views/comercial/Cliente";
import DocumentosEmitidos from "../views/comercial/DocumentosEmitidos";
import VendasPorPeriodoReport from "../views/relatorios/Vendas";
import VendasPorUsuarioReport from "../views/relatorios/VendasPorUser";
import FluxoCaixa from "../views/relatorios/FluxoCaixa";
import EmitirDocumento from "../views/comercial/EmitirDocumento";
import NotaCredito from "../views/comercial/NotaCredito";
import NotaDebito from "../views/comercial/NotaDebito";
import EmitirRecibo from "../views/comercial/Recibo";
import Settings from "../views/Settings";
import DashboardCliente from "../views/DashboardClient";
import DashboardFinanceiro from "../views/DashboardFinanceiro";
import DashboardProduto from "../views/DashboardProdutos";
import DashboardFatura from "../views/DashboardFaturas";
import DashboardProdutos from "../views/DashboardProdutos";
import ContaCorrente from "../views/relatorios/ContaCorrente";
import ExpiredLicense from "../views/Expired";
import ResetPassword from "../views/ResetPassword";
import GerarSaft from "../views/relatorios/SAFT";
import LicenseRenew from "../views/Renovar";


const routes = createHashRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Index />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <ProtectedRoute>
        <Login />
      </ProtectedRoute>
    ),
  },
  {
    path: "/auth/cadastro",
    element: (
      <ProtectedRoute>
        <Cadastro />
      </ProtectedRoute>
    ),
  },
  {
    path: "/auth/recuperar-senha",
    element: (
      <ProtectedRoute>
        <PasswordResetForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/auth/redefinir-senha",
    element: (
      <ProtectedRoute>
        <ResetPassword />
      </ProtectedRoute>
    ),
  },
  {
    path: "/license/renovar",
    element: (
      <PrivateRoute>
        <LicenseRenew />
      </PrivateRoute>
    ),
  },
  {
    path: "/license/expirada",
    element: (
      <PrivateRoute>
        <ExpiredLicense />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/logout",
    element: <Logout />
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
   },
   {
    path: "/estatisticas/clientes",
    element: (
      <PrivateRoute>
        <DashboardCliente />
      </PrivateRoute>
    ),
   },
   {
    path: "/estatisticas/produtos/",
    element: (
      <PrivateRoute>
        <DashboardProdutos />
      </PrivateRoute>
    ),
   },
   {
    path: "/estatisticas/faturas",
    element: (
      <PrivateRoute>
        <DashboardFatura />
      </PrivateRoute>
    ),
   },
   {
    path: "/settings",
    element: (
      <PrivateRoute>
        <Settings />
      </PrivateRoute>
    ),
   },
  {
    path: "/armazem/produtos",
    element: (
      <PrivateRoute>
        <Produtos />
      </PrivateRoute>
    ),
  },
  {
    path: "/armazem/estoque/entrada",
    element: (
      <PrivateRoute>
        <EntradaEstoque />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/clientes",
    element: (
      <PrivateRoute>
        <Clientes />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/emitir-documento/",
    element: (
      <PrivateRoute>
        <EmitirDocumento />
      </PrivateRoute>
    ),
  },
  {
    path: "/pos/painel-caixas/",
    element: (
      <PrivateRoute>
        <EmitirDocumento />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/nota-credito/:id/",
    element: (
      <PrivateRoute>
        <NotaCredito />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/nota-debito/:id/",
    element: (
      <PrivateRoute>
        <NotaDebito />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/emitir-recibo/:id/",
    element: (
      <PrivateRoute>
        <EmitirRecibo />
      </PrivateRoute>
    ),
  },
  {
    path: "/faturacao/documentos/emitidos",
    element: (
      <PrivateRoute>
        <DocumentosEmitidos />
      </PrivateRoute>
    ),
  },
  {
    path: "/relatorios/vendas/",
    element: (
      <PrivateRoute>
        <VendasPorPeriodoReport />
      </PrivateRoute>
    ),
  },
  {
    path: "/relatorios/conta-corrente/",
    element: (
      <PrivateRoute>
        <ContaCorrente />
      </PrivateRoute>
    ),
  },
  {
    path: "/relatorios/financeiro/",
    element: (
      <PrivateRoute>
        <FluxoCaixa />
      </PrivateRoute>
    ),
  },
  {
    path: "/relatorios/usuario/",
    element: (
      <PrivateRoute>
        <VendasPorUsuarioReport />
      </PrivateRoute>
    ),
  },
   {
    path: "/relatorios/ficheiro-saft/",
    element: (
      <PrivateRoute>
        <GerarSaft />
      </PrivateRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default routes;
